import Field from "formiojs/components/_classes/field/Field";
import editForm from "./ImageSelector.form";
import "bootstrap/dist/css/bootstrap.min.css";
import config from "../../config/config";
export default class ImageSelector extends Field {
  static schema(...extend) {
    return Field.schema({
      type: "imageselector",
      label: "Select Logo",
      key: "imageSelector",
      buttonStyle: "btn-primary",
      description: "",
      ...extend,
    });
  }

  static get builderInfo() {
    return {
      title: "Image Selector",
      icon: "fa fa-picture-o",
      group: "basic",
      weight: 70,
      schema: ImageSelector.schema(),
    };
  }

  static editForm = editForm;

  get defaultSchema() {
    return ImageSelector.schema();
  }

  constructor(...args) {
    super(...args);
    this.images = [];
    this.totalCount = 0;
    this.offset = 0;
    this.limit = 20;
    this.searchKeyword = "";
    this.viewType = "grid"; // default view
  }
  render11() {
    return super.render(`
    <div>
      <button type="button" 
              class="btn ${
                this.component.buttonStyle || "btn-primary"
              } select-image-btn">
        ${
          this.dataValue
            ? "Change Logo"
            : this.component.label || "Select Logo"
        }
      </button>
      ${
        this.dataValue
          ? `
        <button type="button" class="btn btn-danger ms-2 remove-image-btn">Remove Image</button>
      `
          : ""
      }
      ${
        this.component.description ? `<p>${this.component.description}</p>` : ""
      }
      <div class="selected-image-preview mt-2">
        ${
          this.dataValue
            ? `<img src="${this.dataValue}" style="max-width: 150px;" />`
            : ""
        }
      </div>
    </div>
  `);
  }
  render() {
    return super.render(`
    <div>
      <button type="button" 
              class="btn ${
                this.component.buttonStyle || "btn-primary"
              } select-image-btn">
        ${
          this.dataValue
            ? "Change Logo"
            : this.component.label || "Select Logo"
        }
      </button>
      ${
        this.dataValue
          ? `
        <button type="button" class="btn btn-danger ms-2 remove-image-btn">Remove Logo</button>
      `
          : ""
      }
      ${
        this.component.description ? `<p>${this.component.description}</p>` : ""
      }
      <div class="selected-image-preview mt-2">
        ${
          this.dataValue
            ? `<img src="${this.dataValue}" style="max-width: 150px;" />`
            : ""
        }
      </div>
    </div>
  `);
  }

  attach(element) {
    super.attach(element);

    const selectBtn = element.querySelector(".select-image-btn");
    if (selectBtn) {
      this.addEventListener(selectBtn, "click", () => this.openModal());
    }

    const removeBtn = element.querySelector(".remove-image-btn");
    if (removeBtn) {
      this.addEventListener(removeBtn, "click", () => {
        console.log("Remove clicked");
        this.dataValue = null; // clear stored value
        this.updateValue(null); // notify Formio
        this.triggerChange(); // trigger change event
        this.redraw(); // force UI to update
      });
    }

    return element;
  }

  openModal() {
    const oldModal = document.querySelector(".image-selector-modal");
    if (oldModal) oldModal.remove();

    const modal = document.createElement("div");
    modal.className = "modal fade show image-selector-modal";
    modal.style.display = "block";
    modal.style.background = "rgba(0,0,0,0.5)";
    modal.tabIndex = -1;

    modal.innerHTML = `
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Select Logo</h5>
          <button type="button" class="btn-close close-modal-btn"></button>
        </div>
        <div class="modal-body">
          <div class="mb-2 d-flex justify-content-between align-items-center">
            <input type="text" class="form-control search-input w-50" placeholder="Search logos..." />
            <div class="btn-group view-toggle ms-2" role="group">
              <button type="button" class="btn btn-outline-secondary active" data-view="grid">Grid</button>
              <button type="button" class="btn btn-outline-secondary" data-view="list">List</button>
              <button type="button" class="btn btn-outline-secondary" data-view="medium">Medium</button>
            </div>
          </div>
          <div>Total images: <span class="total-count">0</span></div>
          <div class="image-list d-flex flex-wrap"></div>
          <div class="d-flex justify-content-between align-items-center mt-2">
            <div>
              <select class="form-select page-size-select" style="width: auto; display: inline-block;">
                ${[10, 20, 50, 100]
                  .map(
                    (size) =>
                      `<option value="${size}" ${
                        size === this.limit ? "selected" : ""
                      }>${size}</option>`
                  )
                  .join("")}
              </select>
              <span class="current-page-info ms-2">Page 1</span>
            </div>
            <div class="btn-group pagination-controls" role="group">
              <button type="button" class="btn btn-secondary prev-btn">Previous</button>
              <button type="button" class="btn btn-secondary next-btn">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

    document.body.appendChild(modal);

    modal
      .querySelector(".close-modal-btn")
      .addEventListener("click", () => modal.remove());

    modal.querySelector(".search-input").addEventListener("input", (e) => {
      this.searchKeyword = e.target.value;
      this.offset = 0;
      this.loadImages(modal);
    });

    modal.querySelector(".page-size-select").addEventListener("change", (e) => {
      this.limit = parseInt(e.target.value, 10);
      this.offset = 0;
      this.loadImages(modal);
    });

    modal.querySelector(".prev-btn").addEventListener("click", () => {
      if (this.offset >= this.limit) {
        this.offset -= this.limit;
        this.loadImages(modal);
      }
    });

    modal.querySelector(".next-btn").addEventListener("click", () => {
      if (this.offset + this.limit < this.totalCount) {
        this.offset += this.limit;
        this.loadImages(modal);
      }
    });

    modal.querySelectorAll(".view-toggle button").forEach((btn) => {
      btn.addEventListener("click", () => {
        modal
          .querySelectorAll(".view-toggle button")
          .forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        this.viewType = btn.dataset.view;
        this.renderImages(modal);
      });
    });

    this.loadImages(modal);
  }

  async loadImages(modal) {
    const listDiv = modal.querySelector(".image-list");
    listDiv.innerHTML = "Loading...";

    const { images, totalCount } = await this.fetchImages();
    this.images = images;
    this.totalCount = totalCount;

    modal.querySelector(".total-count").textContent = totalCount;

    // Update page info
    const currentPage = Math.floor(this.offset / this.limit) + 1;
    const totalPages = Math.ceil(totalCount / this.limit);
    modal.querySelector(
      ".current-page-info"
    ).textContent = `Page ${currentPage} of ${totalPages || 1}`;

    // Enable/disable buttons
    const prevBtn = modal.querySelector(".prev-btn");
    const nextBtn = modal.querySelector(".next-btn");
    prevBtn.disabled = this.offset === 0;
    nextBtn.disabled = this.offset + this.limit >= totalCount;

    this.renderImages(modal);
  }

  renderImages(modal) {
    const listDiv = modal.querySelector(".image-list");
    listDiv.innerHTML = "";

    if (!this.images.length) {
      listDiv.innerHTML = "<p>No images found.</p>";
      return;
    }

    this.images.forEach((img) => {
      const container = document.createElement("div");
      container.style.cursor = "pointer";
      container.className =
        this.viewType === "list"
          ? "w-100 d-flex align-items-center mb-2 border p-2"
          : "m-2";

      if (this.viewType === "grid") {
        container.style.width = "100px";
      } else if (this.viewType === "medium") {
        container.style.width = "150px";
      }

      const imgEl = document.createElement("img");
      imgEl.src = config.ICON_PANEL_APP_URL + img.url;
      imgEl.title = img.title;
      imgEl.style.width =
        this.viewType === "medium"
          ? "140px"
          : this.viewType === "grid"
          ? "90px"
          : "60px";
      imgEl.style.marginRight = "10px";

      container.appendChild(imgEl);
      if (this.viewType === "list" || this.viewType === "medium") {
        const title = document.createElement("span");
        title.textContent = img.title;
        container.appendChild(title);
      }

  
      container.addEventListener("click", () => {
        const fullUrl = config.ICON_PANEL_APP_URL + img.url;
        this.dataValue = fullUrl; // update value
        this.updateValue(fullUrl); // tell Formio
        this.triggerChange(); // notify change
        modal.remove();
        this.redraw(); // force UI update
      });

      listDiv.appendChild(container);
    });
  }
 
  async fetchImages() {
    try {
        
        const payload = {
            community_id: localStorage.getItem("community_id") || 3024,
            community_number:
              localStorage.getItem("community_number") || "0653500130",
            email:
              localStorage.getItem("email") || "k.sianavas@itom-consulting.de",
            first_name: localStorage.getItem("first_name") || "Kosta",
            last_name: localStorage.getItem("last_name") || "Sianavas",
            source_of_call: "OZG-MANAGER",
            remember_minutes: 7200,
          };

          console.log('api url', config.ICON_PANEL_API_URL + "/token");
          const response = await fetch(config.ICON_PANEL_API_URL + "/token", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          });

          const token_data = await response.json();
          console.log('token_data', token_data);
          const token = token_data?.data?.token;

          if (!token) throw new Error("Token not found in response");

          
     
    console.log('api url', config.ICON_PANEL_API_URL + "/token");
      const res = await fetch(
        config.ICON_PANEL_API_URL + "/icon/list",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            offset: this.offset,
            limit: this.limit,
            icon_type: "ICON",
            search_keyword: this.searchKeyword,
            sort_by: "name",
            order_direction: "ASC",
          }),
        }
      );
      const data = await res.json();
      return {
        images:
          data?.data?.icons?.map((icon) => ({
            url: icon.icon_path,
            title: icon.icon_name,
          })) || [],
        totalCount: data?.data?.iconCount || 0,
      };
    } catch (e) {
      console.error("Fetch logo failed", e);
      return { images: [], totalCount: 0 };
    }
  }
  get buttonLabel() {
    return this.dataValue
      ? "Change Logo"
      : this.component.label || "Select Logo";
  }
}
